/**
 * External dependencies
 */
import { Component, RawHTML, Fragment } from '@wordpress/element';
import { Button, Popover } from '@wordpress/components';

/**
 * Internal dependencies
 */
import './style.scss';

class CalendarPopover extends Component {
	constructor( props ) {
		super( props );

		this.state = {
			showPicker: false,
		};
	}

	createFragment( el, text, attr ) {
		let _el = jQuery( '<' + el + '/>' );

		function isHTML( str ) {
			return ( str.indexOf( '</' ) !== -1 || str.indexOf( '/>' ) !== -1 );
		}

		if ( text && text.length && ! isHTML( text ) ) {
			_el.text( text );
		}

		if ( text && text.length && isHTML( text ) ) {
			_el.html( text );
		}

		if ( attr ) {
			_el.attr( attr );
		}

		return _el;
	}

	content = () => {
		const attr = this.props.element.attributes;

		let header_fragment = this.createFragment( 'div', '', {
			id: 'event_detail_header'
		} );

		let footer_fragment = this.createFragment( 'div', '', {
			id: 'event_detail_footer'
		} );

		let body_fragment = this.createFragment( 'div', '', {
			id: 'event_detail_body'
		} );

		header_fragment
			.append( this.createFragment( 'h3', attr.getNamedItem( 'data-booking-title' ).value ) );

		footer_fragment
			.append( this.createFragment( 'a', wc_bookings_admin_js_params.i18n_view_details, {
				href: attr.getNamedItem( 'data-booking-url' ).value
			} ) )
			.append( this.createFragment( 'span' ), '&rarr;' );

		let ul_fragment = this.createFragment( 'ul' );

		if ( attr.getNamedItem( 'data-booking-date' ).value && attr.getNamedItem( 'data-booking-time' ).value ) {
			let item1 = this.createFragment( 'li', '<span/>' + '<strong>' + attr.getNamedItem( 'data-booking-date' ).value + '<br/>' + attr.getNamedItem( 'data-booking-time' ).value + '</strong>', {
				class: 'daily_popover_datetime_icon'
			} );
			ul_fragment.append( item1 );
		}

		if ( attr.getNamedItem( 'data-booking-customer' ).value ) {
			let item2 = this.createFragment( 'li', '<span/>' + this.createFragment( 'strong', wc_bookings_admin_js_params.i18n_customer ).get( 0 ).outerHTML + attr.getNamedItem( 'data-booking-customer' ).value, {
				class: 'daily_popover_customer_icon'
			} );
			ul_fragment.append( item2 );
		}

		if ( attr.getNamedItem( 'data-booking-resource' ).value ) {
			let item3 = this.createFragment( 'li', '<span />' + this.createFragment( 'strong', wc_bookings_admin_js_params.i18n_resource ).get( 0 ).outerHTML + attr.getNamedItem( 'data-booking-resource' ).value.split( ',' ).join( '<br/>' ), {
				class: 'daily_popover_resource_icon'
			} );
			ul_fragment.append( item3 );
		}

		if ( attr.getNamedItem( 'data-booking-persons' ).value ) {
			let item4 = this.createFragment( 'li', '<span />' + this.createFragment( 'strong', wc_bookings_admin_js_params.i18n_persons ).get( 0 ).outerHTML + attr.getNamedItem( 'data-booking-persons' ).value, {
				class: 'daily_popover_persons_icon'
			} );
			ul_fragment.append( item4 );
		}

		const output_fragment = jQuery( '<div/>' ).prepend( body_fragment.append( ul_fragment ) ).prepend( header_fragment ).append( footer_fragment );

		return output_fragment.html();
	}

	toggleVisibility = ( e ) => {
		e.preventDefault();

		const { showPicker } = this.state;
		this.setState( {
			showPicker: ! showPicker,
		} );
	}

	closePopover = () => {
		this.setState( {
			showPicker: false,
		} );
	}

	parseStyles = ( styles ) => styles
    	.split( ';' )
   		.filter( style => style.split( ':' )[ 0 ] && style.split( ':' )[ 1 ] )
    	.map( style => [
        	style.split( ':' )[ 0 ].trim().replace( /-./g, c => c.substr( 1 ).toUpperCase() ),
        	style.split( ':' )[ 1 ].trim()
    	] )
    	.reduce( ( styleObj, style ) => ( {
        	...styleObj,
        	[ style[ 0 ] ]: style[ 1 ],
    } ), {} );

	render() {
		const { showPicker } = this.state;
		const attr = this.props.element.attributes;
		const classes = attr.getNamedItem( 'data-classes' ) ? attr.getNamedItem( 'data-classes' ).value : '';
		const time = attr.getNamedItem( 'data-booking-time' ) ? attr.getNamedItem( 'data-booking-time' ).value : '';
		const bookingTitle = attr.getNamedItem( 'data-booking-title' ) ? attr.getNamedItem( 'data-booking-title' ).value : '';
		const bookingCustomer = attr.getNamedItem( 'data-booking-customer' ) ? attr.getNamedItem( 'data-booking-customer' ).value : '';
		const bookingDescription = bookingCustomer + ( bookingCustomer ? ', ' : '' ) + bookingTitle;
		const styles = attr.getNamedItem( 'data-style' ) ? this.parseStyles( attr.getNamedItem( 'data-style' ).value ) : {};
		const url = attr.getNamedItem( 'data-url' ) ? attr.getNamedItem( 'data-url' ).value : '';
		const position = this.props.position;

		return (
			<Fragment>
				<a href={ url } className={ classes } style={ styles } onClick={ this.toggleVisibility }>
					<span className="booking-calendar-booking-title">{ bookingDescription }</span>
					<span className="booking-calendar-time-range">{ time }</span>
				</a>
				{ showPicker && (
					<Popover
						className="wc-bookings-calendar-popover"
						focusOnMount={ 'firstElement' }
						position={ position }
						onFocusOutside={ this.closePopover }
					>
						<Button className="wc-bookings-calendar-popover-close" onClick={ this.closePopover } >
							Close
						</Button>
						<RawHTML>{ this.content() }</RawHTML>
					</Popover>
				) }
			</Fragment>
		);
	}
}

export default CalendarPopover;
